module.exports = __webpack_public_path__ + "static/img/matanza-digital-2.acee389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/matanza-digital-2.jpg
// module id = eWi6
// module chunks = 1